import selectSingleElement from "../dom/selectSingleElement";
import { DESCRIPTION_TEXT } from "./_selectors";

export function toggleDescription(previousMaterial: string, materialName: string) {
	console.log(
		`toggleDescription called with: previousMaterial="${previousMaterial}", materialName="${materialName}"`,
	);

	// hide previous description
	const prevMaterial = selectSingleElement<HTMLDivElement>(`${DESCRIPTION_TEXT}.show`);
	if (prevMaterial) {
		prevMaterial.classList.remove("show");
		console.log("Hid previous description:", prevMaterial.getAttribute("data-id"));
	}

	// Show new description
	const newMaterial = selectSingleElement(`${DESCRIPTION_TEXT}[data-id="${materialName}"]`);
	if (newMaterial) {
		newMaterial.classList.add("show");
		console.log("Showed new description:", materialName);
	} else {
		console.warn(`Could not find description element with data-id="${materialName}"`);
		// List all available data-ids for debugging
		const allDescriptions = document.querySelectorAll(DESCRIPTION_TEXT);
		console.log(
			"Available description data-ids:",
			Array.from(allDescriptions).map((el) => el.getAttribute("data-id")),
		);
	}
}
